import { broadcastCookieChange } from './actions';

/**
 * Redux middleware that dispatches specific cookieReducer action each time index change
 * Should be used before other middlewares to cover most of the cases, such as thunked actions
 */
function createCookiesMiddleware() {
  let cachedCookies;
  let callDepth = 0;

  return ({ dispatch }) =>
    (next) =>
    (action) => {
      callDepth += 1;
      const result = next(action);
      callDepth -= 1;
      if (callDepth === 0 && typeof document !== 'undefined' && document.cookie !== cachedCookies) {
        cachedCookies = document.cookie;
        dispatch(broadcastCookieChange());
      }
      return result;
    };
}

export const cookieObserverMiddleware = createCookiesMiddleware();
